import api from './api'

export const authService = {
  signUp: async (data) => {
    const response = await api.post('/auth/sign_up', data)
    return response.data
  },

  signIn: async (data) => {
    const response = await api.post('/auth/sign_in', data)
    return response.data
  },

  signOut: async () => {
    await api.post('/auth/sign_out')
  },

  sendVerificationOTP: async (data) => {
    const response = await api.post('/auth/verification_otp/send', data)
    return response.data
  },

  verifyEmail: async (data) => {
    const response = await api.post('/auth/verify_email', data)
    return response.data
  },

  forgotPassword: async (data) => {
    const response = await api.post('/auth/password/forgot', data)
    return response.data
  },

  resetPassword: async (data) => {
    const response = await api.post('/auth/password/reset', data)
    return response.data
  },

  getSession: async () => {
    const response = await api.get('/auth/session', { skipAuthRedirect: true })
    return response.data
  },
}

